let api = {
    exterfaceInvoke: {
        method: 'POST',
        path: process.env.VUE_APP_BASE_URL,
        origin: true
    }, //标准用户登录
}

export default api